<template>
  <div>
    <button v-if="type !== 'subscription'" @click="callback(name, 1)" class="btn">
      <i class="fal fa-plus"></i>
    </button>
    <button @click="callback(name, -1)" class="btn">
      <i class="fal fa-minus"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    callback: Function,
    name: String,
    type: {
      type: String,
      required: false,
      default: ''
    }
  },
}
</script>

<style lang="scss" scoped>
.btn:first-child {
  padding-right: 0px;
}
i {
  font-size: 26px !important;
}
</style>
